<mat-card appearance="outlined">
  <mat-card-title>
    <span class="title">{{ 'nssi.standalonePageTitle' | translate }}</span>
  </mat-card-title>
  <mat-card-subtitle>
  </mat-card-subtitle>
  <mat-card-content>
    <form>
      <div layout="column" class="title" flex-gt-md="50">
        <mat-form-field
          class="white-space-no-wrap right-padding-16"
          [style.max-width.px]="300">
          <input
            matInput
            type="text"
            [formControl]="civilId"
            placeholder="{{ 'global.civilId' | translate }}"
            />
            @if (civilId.hasError('onlyNumbers') || civilId.hasError('minlength') || civilId.hasError('maxlength') || civilId.hasError('incorrectEgnFormat')) {
              <mat-error
                [translate]="'clients.invalidCivilId'">Invalid civil id
              </mat-error>
            }
          </mat-form-field>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
  @if (showTable) {
    <mat-card appearance="outlined">
      <mat-card-content>
        <div >
          <itfg-nssi-report [client]="client" [creditId]="null"></itfg-nssi-report>
        </div>
      </mat-card-content>
    </mat-card>
  }
  @if (!showTable) {
    <div layout="row" layout-align="center">
      <h3 class="edit-screen-card-title">{{ 'nssi.enterValidCivilId' | translate }}</h3>
    </div>
  }
